import type { RootState } from '@app/types';

import { type ProjectPermissions, ProjectType } from '../../../types/project';

export const generateProjectsStoreStateProject = (
    overwrite?: Partial<RootState['projects']['projectsList']['list'][0]>,
): RootState['projects']['projectsList']['list'][0] => ({
    name: 'Sample Project',
    id: '9777977860c35ec49cc4b1.15807104',
    type: ProjectType.localizationFiles,
    description: '',
    langs: [
        {
            id: '10153',
            name: 'Latvian',
            isDefault: false,
            isEditable: true,
            langIso: 'lv',
            ccIso: 'lv',
            plural: null,
            stats: { wordCount: 0, percentTranslatedTotal: 0, wordCountUntranslated: 9, calcIsFuzzy: 0 },
        },
        {
            id: '800',
            name: 'Latvian (Latvia)',
            isDefault: false,
            isEditable: true,
            langIso: 'lv_LV',
            ccIso: 'lv',
            plural: null,
            stats: { wordCount: 0, percentTranslatedTotal: 0, wordCountUntranslated: 9, calcIsFuzzy: 0 },
        },
        {
            id: '640',
            name: 'English',
            isDefault: true,
            isEditable: true,
            langIso: 'en',
            ccIso: 'us',
            plural: null,
            stats: {
                wordCount: 191,
                percentTranslatedTotal: 86.66666666666667,
                wordCountUntranslated: 0,
                calcIsFuzzy: 1,
            },
        },
        {
            id: '602',
            name: 'Chinese Simplified',
            isDefault: false,
            isEditable: true,
            langIso: 'zh_CN',
            ccIso: 'cn',
            plural: null,
            stats: { wordCount: 0, percentTranslatedTotal: 0, wordCountUntranslated: 191, calcIsFuzzy: 4 },
        },
        {
            id: '673',
            name: 'French',
            isDefault: false,
            isEditable: true,
            langIso: 'fr',
            ccIso: 'fr',
            plural: null,
            stats: {
                wordCount: 32,
                percentTranslatedTotal: 15.18324607329843,
                wordCountUntranslated: 162,
                calcIsFuzzy: 3,
            },
        },
        {
            id: '666',
            name: 'German',
            isDefault: false,
            isEditable: true,
            langIso: 'de',
            ccIso: 'de',
            plural: null,
            stats: {
                wordCount: 4,
                percentTranslatedTotal: 2.094240837696335,
                wordCountUntranslated: 187,
                calcIsFuzzy: 4,
            },
        },
        {
            id: '766',
            name: 'Hebrew',
            isDefault: false,
            isEditable: true,
            langIso: 'he',
            ccIso: 'il',
            plural: null,
            stats: {
                wordCount: 3,
                percentTranslatedTotal: 1.5706806282722512,
                wordCountUntranslated: 188,
                calcIsFuzzy: 4,
            },
        },
        {
            id: '643',
            name: 'Japanese',
            isDefault: false,
            isEditable: true,
            langIso: 'ja',
            ccIso: 'jp',
            plural: null,
            stats: {
                wordCount: 9,
                percentTranslatedTotal: 1.5706806282722512,
                wordCountUntranslated: 188,
                calcIsFuzzy: 4,
            },
        },
        {
            id: '10001',
            name: 'MyCustomName',
            isDefault: false,
            isEditable: true,
            langIso: 'custom_1',
            ccIso: '',
            plural: null,
            stats: { wordCount: 0, percentTranslatedTotal: 0, wordCountUntranslated: 191, calcIsFuzzy: 2 },
        },
        {
            id: '909',
            name: 'Rundi',
            isDefault: false,
            isEditable: true,
            langIso: 'rn',
            ccIso: 'rn',
            plural: null,
            stats: {
                wordCount: 103,
                percentTranslatedTotal: 70.68062827225131,
                wordCountUntranslated: 56,
                calcIsFuzzy: 4,
            },
        },
    ],
    filenames: [],
    availableRefLang: '640',
    projectContributors: '2',
    allKeysCount: '15',
    isBranchingEnabled: false,
    isOtaEnabled: false,
    offlineTranslation: false,
    mau: 0,
    branches: null,
    isAdmin: true,
    isCollapsed: false,
    adminRights: {
        upload: true,
        download: true,
        tasks: true,
        contributors: true,
        screenshots: true,
        manageKeys: true,
        manageLanguages: true,
        settings: true,
        createBranches: true,
        mergeBranches: false,
        activity: true,
        statistics: true,
    },
    stats: {
        percentTranslatedTotal: 22.220767888307158,
        baseWordCount: 191,
        qaTotalCount: 149,
        display: {
            qa_not_proofread: 120,
            calc_is_fuzzy: 26,
            calc_qa_spelling_and_grammar: 1,
            calc_qa_mismatch_placeholder: 1,
            calc_qa_mismatch_html: 1,
        },
    },
    statsLoaded: true,
    permissions: {
        tasks: false,
        review: false,
        upload: false,
        activity: false,
        download: false,
        settings: false,
        statistics: false,
        manageKeys: false,
        screenshots: false,
        contributors: false,
        glossaryEdit: false,
        glossaryManage: false,
        branchesMerge: false,
        branchesCreate: false,
        manageLanguages: false,
        branchesMainModify: false,
        customStatusModify: false,
    },
    ...overwrite,
});

export const generateProjectPermissions = (defaultValue = false, overrides: Partial<ProjectPermissions> = {}) => ({
    manageKeys: defaultValue,
    tasks: defaultValue,
    review: defaultValue,
    upload: defaultValue,
    activity: defaultValue,
    download: defaultValue,
    settings: defaultValue,
    statistics: defaultValue,
    screenshots: defaultValue,
    contributors: defaultValue,
    glossaryEdit: defaultValue,
    branchesMerge: defaultValue,
    branchesCreate: defaultValue,
    glossaryManage: defaultValue,
    manageLanguages: defaultValue,
    branchesMainModify: defaultValue,
    customStatusModify: defaultValue,
    ...overrides,
});
